import { render, staticRenderFns } from "./Metabase.vue?vue&type=template&id=813b7784&"
import script from "./Metabase.vue?vue&type=script&lang=js&"
export * from "./Metabase.vue?vue&type=script&lang=js&"
import style0 from "./Metabase.vue?vue&type=style&index=0&id=813b7784&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports